import axios from "axios";

const prepareData = (data) => ({ comment: data });

export const GET_COMMENTS = "get_comments";
export const getComments = (commentableType, commentableId) => {
  const request = axios.get("/comments.json", {
    params: { commentable_type: commentableType, commentable_id: commentableId },
  });
  return {
    type: GET_COMMENTS,
    payload: request,
    meta: { commentableType, commentableId },
  };
};

export const CREATE_COMMENT = "create_comment";
export const createComment = (data) => {
  const request = axios({ method: "post", url: "/comments.json", data: prepareData(data) });
  return {
    type: CREATE_COMMENT,
    payload: request,
    meta: {
      commentableType: data.commentable_type,
      commentableId: data.commentable_id,
    },
  };
};

export const DESTROY_COMMENT = "destroy_comment";
export const destroyComment = (id, meta = {}) => {
  const request = axios({ method: "delete", url: `/comments/${id}.json` });
  return {
    type: DESTROY_COMMENT,
    payload: request,
    meta,
  };
};
